import { LabellerAccuracyStats } from "src/store/api/generatedApi";

export type LabellerAccuracyCounts = Pick<
  LabellerAccuracyStats,
  | "match_accuracy"
  | "matched_events"
  | "total_labeller_events"
  | "total_verified_events"
>;

export const falsePositiveRate = (
  accuracy: LabellerAccuracyCounts | null | undefined
): number | undefined => {
  if (accuracy?.match_accuracy == null) return undefined;
  const denominator = accuracy.total_labeller_events;
  if (denominator === 0) return undefined;
  return (
    (accuracy.total_labeller_events - accuracy.matched_events) / denominator
  );
};

export const falseNegativeRate = (
  accuracy: LabellerAccuracyCounts | null | undefined
): number | undefined => {
  if (accuracy?.match_accuracy == null) return undefined;
  const denominator = accuracy.total_verified_events;
  if (denominator === 0) return undefined;
  return (
    (accuracy.total_verified_events - accuracy.matched_events) / denominator
  );
};

export const falsePositiveRateCsv = (
  accuracy: LabellerAccuracyCounts | null | undefined
): number | null => {
  if (accuracy == null || accuracy.total_labeller_events === 0) return null;
  return (
    (accuracy.total_labeller_events - accuracy.matched_events) /
    accuracy.total_labeller_events
  );
};

export const falseNegativeRateCsv = (
  accuracy: LabellerAccuracyCounts | null | undefined
): number | null => {
  if (accuracy == null || accuracy.total_verified_events === 0) return null;
  return (
    (accuracy.total_verified_events - accuracy.matched_events) /
    accuracy.total_verified_events
  );
};
